import { ButtonClassType, IconPosition } from '../../../../enums/buttons';
const iconButtonStyles = `
  &.kpmg-button-${ButtonClassType.Icon} {
    height: 25px;
    width: 25px;
    background-color: transparent;
    padding: 0;
    margin: 0;

    &.icon-position-${IconPosition.Left} svg, &.icon-position-${IconPosition.Right} svg {
      margin: 0px;
    }

    &.disabled {
      cursor: default;
    }
  }
`;
export default iconButtonStyles;
